import React, { useEffect } from "react";

export default function GTMScript() {
  const trackingId = process.env.GATSBY_GTM_TRACKING_ID;

  useEffect(() => {
    if (!trackingId) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
      cookie_name: 'lh_gtm_cookie',
      cookie_domain: window.location.hostname,
      cookie_expires: 365 * 24 * 60 * 60 // 1 año
    });

    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtm.js?id=${trackingId}&l=dataLayer`;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return <>
    {
      trackingId && <noscript key="gtm-noscript">
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${process.env.trackingId}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="Google Tag Manager"
        />
      </noscript>
    }
  </>;
}